import { EditorialMessageContent } from "./EditorialMessageContent";
import { DataRelatedBuilder } from "./DataRelatedBuilder";
import { AuthorMini } from "../../shared/models/Author";
import { PostI3 } from "../../shared/models/postI3";
import { truncateSummary } from "../services/summary.service";
import { getImagePath } from "../utils/pathHelper";
import { MessageContent } from "./MessageContent";

export class PostDataRelatedBuilder implements DataRelatedBuilder <PostI3> {
  build(post: PostI3, content: EditorialMessageContent, author: AuthorMini): MessageContent {
    content.relatedPostContent = {
      PostId: post.id,
      PostUrl: post.url,
      Title: post.title,
      ContentType: post.contentType,
      PublicationDateUtc: post.publicationDate,
      ImageUrl: getImagePath(post.imageUrl, "Small"),
      Duration: post.summary,
      AuthorName: author.Name,
      AuthorImageUrl: getImagePath(author.UrlPhoto, "XtraSmall"),
      Summary: truncateSummary(post.summary),
      IsPremium: post.isPremium
    }
    content.relatedRecordingContent = null;
    content.relatedWebinarContent = null;
    return content;
  }
}



// WEBPACK FOOTER //
// ./src/app/tradingstudio/models/PostDataRelatedBuilder.ts